<template>
  <v-row justify="center"
  >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          :color="BGColor"
          elevation="0"
        >
          <v-btn
            icon
            :color="Color"
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title :style="{ color: Color }">
            {{ $t('settings.formTerms.cookiePolicy') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              text
              :color="Color"
              @click="onClose"
            >
              {{ $t('common.close', locale)}}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <vue-editor 
          class="main-terms"
          v-model="cookiePolicy"
          :disabled="true"
          :editor-toolbar="aux"
          style="height: calc(100vh);"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  import { mapState } from 'vuex'
const minToolbar = [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]]
import { VueEditor } from 'vue2-editor'
import constants from '@/constants'
import utilsService from '@/services/utils'
import api from '@/services/api'
export default {
  components: {
    VueEditor,
  },
  props: {
    cookiePolicy: {
      type: String,
      requried: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      default: 'es',
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    dialog: false,
    aux: minToolbar,
  }),
  computed: {
    ...mapState('app',['FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'Color']),
    isSimulation () {
      return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
    },
  },
  watch: {
    locale () {
      this.handleGetData()
    },
    show (v) {
      this.dialog = v
    },
  },
}
</script>
<style>
.main-terms .ql-toolbar.ql-snow {
  display: none;
  background-color: red;
}
.ql-container.ql-snow.ql-disabled {
  border: 0;
}
</style>

